import { FC, Fragment } from 'react';
import FilterAndPaginate from '../common/FilterAndPaginate';
import { Button, Icon, Popup, Segment, Table } from 'semantic-ui-react';
import SortableHeaderCell from '../common/SortableHeaderCell';
import Pagination from '../common/Pagination';
import { useDispatch } from 'react-redux';
import { MODAL_COMPONENTS } from '../common/ModalRoot';
import ConfirmWrapper from '../common/ConfirmWrapper';
import ServerConfigurationApi from '../../api/serverConfigurationApi';
import toastr from 'toastr';

const LookUpValuesTable: FC<any> = ({
    paginatedItems,
    handleSortChange,
    handleAddFilter,
    handlePaginationChange,
    paginationOptions,
    uiActions,
    confirmPopupActions,
    fetchLookUpValuesById,
    ...rest
}) => {
    const dispatch = useDispatch();
    const { showConfirmDialog } = confirmPopupActions;
    const handleEdit = (item) => {
        dispatch(
            uiActions.showModal({
                modalType: MODAL_COMPONENTS.SAVE_LOOK_UP_VALUE_MODAL,
                modalProps: {
                    onSuccess: () => fetchLookUpValuesById(item.lookUpTypeId),
                    item,
                },
            }),
        );
    };

    const removeClicked = (item) => {
        showConfirmDialog(
            `Are you sure you want to remove look up value "${item.lookUpValueName}"?`,
            () => handleRemove(item),
        );
    };

    const handleRemove = async (item) => {
        try {
            await ServerConfigurationApi.updateLookUpValue({
                ...item,
                deleted: true,
            });
            toastr.success('Look up value deleted');
            fetchLookUpValuesById(item.lookUpTypeId);
        } catch (error) {
            toastr.error(error);
        }
    };
    const unRemoveClicked = async (item) => {
        try {
            await ServerConfigurationApi.updateLookUpValue({
                ...item,
                deleted: false,
            });
            toastr.success('Look up value restored');
            fetchLookUpValuesById(item.lookUpTypeId);
        } catch (error) {
            toastr.error(error);
        }
    };
    return (
        <>
            <Table celled sortable>
                <Table.Header>
                    <Table.Row>
                        <SortableHeaderCell
                            {...paginationOptions}
                            name="lookUpValueCode"
                            handleSortChange={handleSortChange}
                            handleAddFilter={handleAddFilter}
                            isSearchable={true}
                            isFilterable={false}
                        >
                            Code
                        </SortableHeaderCell>
                        <SortableHeaderCell
                            {...paginationOptions}
                            name="lookUpValueName"
                            handleSortChange={handleSortChange}
                            handleAddFilter={handleAddFilter}
                            isSearchable={true}
                            isFilterable={false}
                        >
                            Value
                        </SortableHeaderCell>
                        <SortableHeaderCell
                            {...paginationOptions}
                            name="lookUpValueOrder"
                            handleSortChange={handleSortChange}
                            handleAddFilter={handleAddFilter}
                            isSearchable={true}
                            isFilterable={false}
                        >
                            Sort Order
                        </SortableHeaderCell>
                        <SortableHeaderCell
                            {...paginationOptions}
                            name="lookUpValueWeight"
                            handleSortChange={handleSortChange}
                            handleAddFilter={handleAddFilter}
                            isSearchable={true}
                            isFilterable={false}
                        >
                            Weight
                        </SortableHeaderCell>
                        <SortableHeaderCell
                            {...paginationOptions}
                            name="lookUpValueMinimumLevel"
                            handleSortChange={handleSortChange}
                            handleAddFilter={handleAddFilter}
                            isSearchable={true}
                            isFilterable={false}
                        >
                            Minimum Level
                        </SortableHeaderCell>
                        <SortableHeaderCell
                            {...paginationOptions}
                            name="lookUpValueDescription"
                            handleSortChange={handleSortChange}
                            handleAddFilter={handleAddFilter}
                            isSearchable={true}
                            isFilterable={false}
                        >
                            Description
                        </SortableHeaderCell>
                        <SortableHeaderCell
                            {...paginationOptions}
                            name="color"
                            handleSortChange={handleSortChange}
                            handleAddFilter={handleAddFilter}
                            isSearchable={true}
                            isFilterable={false}
                        >
                            Color
                        </SortableHeaderCell>
                        <SortableHeaderCell
                            {...paginationOptions}
                            name="deleted"
                            handleSortChange={handleSortChange}
                            handleAddFilter={handleAddFilter}
                            isSearchable={true}
                            isFilterable={false}
                        >
                            Deleted
                        </SortableHeaderCell>
                        <Table.HeaderCell>Actions</Table.HeaderCell>
                    </Table.Row>
                </Table.Header>
                <Table.Body>
                    {paginatedItems.map((item) => (
                        <Table.Row key={item.id}>
                            <Table.Cell>{item.lookUpValueCode}</Table.Cell>
                            <Table.Cell>{item.lookUpValueName}</Table.Cell>
                            <Table.Cell>{item.lookUpValueOrder}</Table.Cell>
                            <Table.Cell>{item.lookUpValueWeight}</Table.Cell>
                            <Table.Cell>
                                {item.lookUpValueMinimumLevel}
                            </Table.Cell>
                            <Table.Cell style={{ whiteSpace: 'pre-line' }}>
                                {item.lookUpValueDescription}
                            </Table.Cell>
                            <Table.Cell>{item.color}</Table.Cell>
                            <Table.Cell>
                                {item.deleted ? (
                                    <Icon color="red" name="x" />
                                ) : (
                                    ''
                                )}
                            </Table.Cell>
                            <Table.Cell collapsing textAlign="center">
                                <Popup
                                    wide
                                    trigger={
                                        <Button
                                            icon="edit"
                                            onClick={() => handleEdit(item)}
                                        />
                                    }
                                    content={'Edit'}
                                    position="top center"
                                />
                                {!item.deleted ? (
                                    <Popup
                                        wide
                                        trigger={
                                            <Button
                                                icon={'trash'}
                                                onClick={() =>
                                                    removeClicked(item)
                                                }
                                            />
                                        }
                                        content={'Delete'}
                                        position="top center"
                                    />
                                ) : (
                                    <Popup
                                        wide
                                        trigger={
                                            <Button
                                                icon={'reply'}
                                                onClick={() =>
                                                    unRemoveClicked(item)
                                                }
                                            />
                                        }
                                        content={'Restore'}
                                        position="top center"
                                    />
                                )}
                            </Table.Cell>
                        </Table.Row>
                    ))}
                </Table.Body>
            </Table>
            <Pagination
                activePage={paginationOptions.activePage}
                onPageChange={handlePaginationChange}
                totalPages={paginationOptions.totalPages}
            />
        </>
    );
};

function mapOptions(props) {
    return {
        items: props.lookUpValues || [],
    };
}

export default FilterAndPaginate(mapOptions)(ConfirmWrapper(LookUpValuesTable));
